import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Image,
  Flex,
  Box,
  Tooltip,
  Input,
  Text,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Button,
  Textarea,
  ModalHeader,
  Select,
  RadioGroup,
  Stack,
  Radio,
  useDisclosure,
  InputGroup,
  InputRightElement,
  useToast,
} from "@chakra-ui/react";
import { Field, Form, Formik, FormikErrors } from "formik";
import down from "@/assets/down.svg";
import { ReactSVG } from "react-svg";
import { useEffect, useState } from "react";
// import "./index.css"
import { ContentPub, ContentPublish } from "@/types/content";
import {
  useGetContentQuery,
  useLazyGetContentQuery,
  useUpdateContentMutation,
} from "@/services/api/endpoints/content";
import { ServerError } from "@/types/errors";
import ContentGroup from "../publish/contentgroup";
type Props = {
  isOpen: boolean;
  onClose: () => void;
  contentId: string;
};

const SettingAiWorksModal = (props: Props) => {
  // const [getContent, { data }] = useLazyGetContentQuery();
  // const [updateContent] = useUpdateContentMutation();
  const groupDisclosure = useDisclosure();
  const [btnBool, setBtnBool] = useState<boolean>();
  const toast = useToast();

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (props.isOpen) {
  //       await getContent(props.contentId);
  //     }
  //   };
  //   fetchData();
  // }, []);

  const data:ContentPublish ={
    id: "",
  content_name: "",
  content_intro: "",
  group_id: "",
  group_name:"",
  image_type: "",
  show: 0,
  download: true,
  water_mark: false,
  water_mark_props:{
    payway: "",
    price: 0
  }
  } as ContentPublish;

  const handleValidate = (values: ContentPublish) => {
    const errors: FormikErrors<ContentPub> = {};
    if (!values.content_name) {
      errors.content_name = "作品名称不能为空";
    }
    if (!values.content_intro) {
      errors.content_intro = "作品简介不能为空";
    }
    return errors;
  };
  const hanldeOnSubmit = async (values: ContentPublish) => {
    console.log(values);
    values.status = true;
    // await updateContent(values)
    //   .unwrap()
    //   .catch((e) => {
    //     toast({
    //       title: (e as ServerError).message,
    //       position: "top",
    //       status: "error",
    //       duration: 2000,
    //       isClosable: true,
    //     });
    //   });
  };
  // const handleSubmitOne = (submitForm: (() => Promise<void>) & (() => Promise<any>)) => {
  //   // 在这里执行第一个按钮的逻辑
  //   setBtnBool(false)
  //   submitForm();
  // };

  // const handleSubmitTwo = (submitForm: (() => Promise<void>) & (() => Promise<any>)) => {
  //   // 在这里执行第二个按钮的逻辑
  //   setBtnBool(true)
  //   submitForm();
  // };
  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      size="xl"
      isCentered
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>修改作品信息</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {data && (
            <Box>
              {/* <Flex padding="20px" border="1px solid #DCE0EB" alignItems={"center"} justifyContent={"center"} flex={1}>
                <Image src={data.image_url} />
              </Flex> */}
              <Box p="20px" overflow="auto" maxHeight="600px">
                <Formik
                  initialValues={data}
                  onSubmit={hanldeOnSubmit}
                  validate={handleValidate}
                >
                  {({ submitForm, setFieldValue, values }) => (
                    <Form>
                      <Field name="content_name">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              form.errors.content_name &&
                              form.touched.content_name
                            }
                            mt={"20px"}
                          >
                            <FormLabel>*作品名称</FormLabel>
                            <Input {...field} placeholder="请输入作品名称" />
                            <FormErrorMessage>
                              {form.errors.content_name}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                      <Field name="content_intro">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              form.errors.content_intro &&
                              form.touched.content_intro
                            }
                            mt={"20px"}
                            mb={"20px"}
                          >
                            <FormLabel>*作品简介</FormLabel>
                            <Textarea placeholder="请输入作品简介" {...field} />
                            <FormErrorMessage>
                              {form.errors.content_intro}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>

                      <Field name="group_id" type="hidden" />
                      <Field name="group_name" type="hidden" />
                      <Flex
                        justifyContent="space-between"
                        alignItems="center"
                        mt="20px"
                        height="40px"
                      >
                        <Text>选择分组</Text>
                        <Flex>
                          <Flex
                            onClick={groupDisclosure.onOpen}
                            pr="6px"
                            cursor={"pointer"}
                          >
                            <Text>
                              {values.group_name
                                ? values.group_name
                                : "点击选择"}
                            </Text>
                            <ReactSVG src={down} />
                          </Flex>
                          <ContentGroup
                            isOpen={groupDisclosure.isOpen}
                            onClose={groupDisclosure.onClose}
                            userId={values.user_id}
                            setFieldValue={setFieldValue}
                          />
                        </Flex>
                      </Flex>
                      <Flex justifyContent="space-between" alignItems="center">
                        <Text>选择分类</Text>
                        <Select
                          icon={<ReactSVG src={down} />}
                          variant="Unstyled"
                          w="150px"
                          value={values.image_type}
                          onChange={(e) => {
                            setFieldValue("image_type", e.target.value, false);
                          }}
                        >
                          <option value="建筑设计">建筑设计</option>
                          <option value="城市规划">城市规划</option>
                          <option value="室内设计">室内设计</option>
                          <option value="景观设计">景观设计</option>
                          <option value="其他">其他</option>
                        </Select>
                      </Flex>
                      <Flex justifyContent="space-between" alignItems="center">
                        <Text>公开范围</Text>
                        <Select
                          icon={<ReactSVG src={down} />}
                          value={values.show}
                          variant="Unstyled"
                          w="150px"
                          onChange={(e) => {
                            setFieldValue(
                              "show",
                              Number(e.target.value),
                              false
                            );
                          }}
                        >
                          <option value={0}>所有人可见</option>
                          <option value={1}>自己可见</option>
                          <option value={2}>关注可见</option>
                        </Select>
                      </Flex>
                      <Flex
                        justifyContent="space-between"
                        alignItems="center"
                        height="40px"
                      >
                        <Text>允许下载</Text>
                        <RadioGroup
                          value={values.download.toString()}
                          onChange={(value) => {
                            setFieldValue("download", value === "true", false);
                          }}
                        >
                          <Stack spacing={5} direction="row">
                            <Radio colorScheme="blue" value="true">
                              允许
                            </Radio>
                            <Radio colorScheme="blue" value="false">
                              不允许
                            </Radio>
                          </Stack>
                        </RadioGroup>
                      </Flex>
                      <Flex
                        justifyContent="space-between"
                        alignItems="center"
                        h="40px"
                      >
                        <Text>下载水印</Text>
                        <RadioGroup
                          value={values.water_mark.toString()}
                          onChange={(value) => {
                            setFieldValue(
                              "water_mark",
                              value === "true",
                              false
                            );
                          }}
                        >
                          <Stack spacing={5} direction="row">
                            <Radio colorScheme="blue" value="true">
                              有水印
                            </Radio>
                            <Radio colorScheme="blue" value="false">
                              无水印
                            </Radio>
                          </Stack>
                        </RadioGroup>
                      </Flex>
                      <Flex
                        justifyContent="space-between"
                        alignItems="center"
                        hidden={values.water_mark}
                      >
                        <Text>付款方式</Text>
                        <Stack direction={"row"} align={"center"}>
                          <Select
                            variant="Unstyled"
                            w="150px"
                            value={values.water_mark_props.payway}
                            onChange={(e) => {
                              setFieldValue(
                                "water_mark_props.payway",
                                e.target.value,
                                false
                              );
                            }}
                          >
                            <option value="积分">积分</option>
                            <option value="现金">现金</option>
                            <option value="免费">免费</option>
                          </Select>
                          <Input
                            placeholder="请输入"
                            type="number"
                            value={values.water_mark_props.price}
                            onChange={(e) => {
                              setFieldValue(
                                "water_mark_props.price",
                                Number(e.target.value),
                                false
                              );
                            }}
                          />
                          {/* <InputGroup size='md'>
                        <Input placeholder='请输入' value={price} onChange={(e)=>setPrice(e.target.value)}/>
                        <InputRightElement width='6rem' fontSize="12px">
                          <Button h='1.5rem' size='sm' color="#27314D" onClick={()=>setWaterMark("true")}>取消</Button>
                          <Button h='1.5rem' size='sm' ml="10px" mr="10px" colorScheme='blue'>确定</Button>
                        </InputRightElement>
                      </InputGroup> */}
                        </Stack>
                      </Flex>
                      <Flex justifyContent={"flex-end"} mt="10px">
                        <Radio colorScheme="blue" size='sm'>用户交易协议</Radio>
                      </Flex>
                      <Flex mt="20px" gap="20px">
                        <Button
                          flex={1}
                          h="54px"
                          mr="15px"
                          bg="#CBD1DF"
                          color={"#27314D"}
                          fontSize="18px"
                          fontWeight={"normal"}
                          borderRadius={0}
                          _hover={{
                            bg: "#CBD1DF",
                            color: "#8E94A9",
                          }}
                        >
                          保存
                        </Button>
                        {!values.status && (
                          <Button
                            type="submit"
                            flex={1}
                            h="54px"
                            bg="#496AE1"
                            color={"#FFFFFF"}
                            fontSize="18px"
                            fontWeight={"normal"}
                            borderRadius={0}
                            _hover={{
                              bg: "#3F5BC1",
                              color: "#E6E6E6",
                            }}
                          >
                            保存并发布
                          </Button>
                        )}
                      </Flex>
                    </Form>
                  )}
                </Formik>
              </Box>
            </Box>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SettingAiWorksModal;
